import connector from "service/connector";

const getPopup = async () => {
  return await connector.connectFetchController("popup", "GET");
};

export { getPopup };
export default { getPopup };
